import React, { useEffect, useState } from 'react'
import { MapContainer, TileLayer, Marker, Popup, Circle, useMapEvents } from 'react-leaflet'
import L from 'leaflet'
import axios from 'axios'
import 'leaflet/dist/leaflet.css'

const API = process.env.REACT_APP_API_URL || 'http://localhost:3001/api'

const TIPOS = [
  { id:'geral',    icone:'📍', label:'Geral' },
  { id:'cliente',  icone:'🏢', label:'Cliente' },
  { id:'obra',     icone:'🏗', label:'Obra' },
  { id:'posto',    icone:'⛽', label:'Posto' },
  { id:'deposito', icone:'📦', label:'Depósito' },
  { id:'hospital', icone:'🏥', label:'Hospital' },
  { id:'escola',   icone:'🏫', label:'Escola' },
  { id:'outro',    icone:'📌', label:'Outro' },
]

function ClicarMapa({ ativo, onCoordenada }: any) {
  useMapEvents({
    click(e) { if (ativo) onCoordenada(e.latlng.lat, e.latlng.lng) }
  })
  return null
}

export default function Pontos() {
  const [pontos, setPontos]         = useState<any[]>([])
  const [visitas, setVisitas]       = useState<any[]>([])
  const [modo, setModo]             = useState<'lista'|'novo'|'visitas'>('lista')
  const [selecionandoMapa, setSelecionandoMapa] = useState(false)
  const [form, setForm]             = useState({
    nome:'', tipo:'geral', latitude:'', longitude:'',
    raio_metros:'100', endereco:'', observacoes:''
  })
  const [abaAtiva, setAbaAtiva]     = useState<'pontos'|'visitas'>('pontos')
  const [filtroPonto, setFiltroPonto] = useState('')

  useEffect(() => { carregar() }, [])

  const carregar = async () => {
    try {
      const [p, v] = await Promise.all([
        axios.get(`${API}/pontos`),
        axios.get(`${API}/pontos/visitas`)
      ])
      setPontos(p.data)
      setVisitas(v.data)
    } catch {}
  }

  const salvar = async () => {
    if (!form.nome || !form.latitude || !form.longitude)
      return alert('Nome e localização são obrigatórios. Clique no mapa para definir o ponto.')
    try {
      await axios.post(`${API}/pontos`, {
        ...form,
        latitude: parseFloat(form.latitude),
        longitude: parseFloat(form.longitude),
        raio_metros: parseInt(form.raio_metros) || 100
      })
      await carregar()
      setModo('lista')
      setForm({ nome:'', tipo:'geral', latitude:'', longitude:'', raio_metros:'100', endereco:'', observacoes:'' })
      setSelecionandoMapa(false)
    } catch (e: any) { alert(e.response?.data?.erro || 'Erro ao salvar') }
  }

  const excluir = async (id: string) => {
    if (!window.confirm('Excluir este ponto?')) return
    try {
      await axios.delete(`${API}/pontos/${id}`)
      setPontos(p => p.filter(x => x.id !== id))
    } catch {}
  }

  const onCoordenada = (lat: number, lng: number) => {
    setForm(f => ({ ...f, latitude: lat.toFixed(7), longitude: lng.toFixed(7) }))
    setSelecionandoMapa(false)
  }

  const formatarDuracao = (min: number) => {
    if (!min) return '—'
    if (min < 60) return `${min}min`
    return `${Math.floor(min/60)}h ${min%60}min`
  }

  const centro: [number,number] = [-3.0, -47.4]
  const tipoAtual = TIPOS.find(t => t.id === form.tipo)

  if (modo === 'novo') return (
    <div style={{ display:'flex', height:'100%', overflow:'hidden' }}>
      {/* Painel */}
      <div style={{ width:340, background:'#1a2744', borderRight:'1px solid #2d4166', display:'flex', flexDirection:'column', overflow:'hidden' }}>
        <div style={{ padding:'14px 16px', borderBottom:'1px solid #2d4166', display:'flex', alignItems:'center', gap:8 }}>
          <button className="btn btn-ghost" style={{ padding:'4px 8px' }} onClick={() => setModo('lista')}>←</button>
          <span style={{ fontWeight:700, fontSize:15 }}>Novo ponto de interesse</span>
        </div>

        <div style={{ flex:1, overflowY:'auto', padding:16 }}>
          <div className="form-group" style={{ marginBottom:12 }}>
            <label>Nome do ponto *</label>
            <input value={form.nome} onChange={e => setForm({...form, nome:e.target.value})} placeholder="Ex: Cliente ABC, Obra Centro..." />
          </div>

          {/* Tipo */}
          <div className="form-group" style={{ marginBottom:12 }}>
            <label>Tipo</label>
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr 1fr', gap:6 }}>
              {TIPOS.map(t => (
                <div key={t.id} onClick={() => setForm({...form, tipo:t.id})}
                  style={{ padding:'8px 4px', borderRadius:8, textAlign:'center', cursor:'pointer',
                    border:`1px solid ${form.tipo===t.id ? '#0ea5e9' : '#2d4166'}`,
                    background: form.tipo===t.id ? '#0c2a4a' : 'transparent' }}>
                  <div style={{ fontSize:18 }}>{t.icone}</div>
                  <div style={{ fontSize:9, color: form.tipo===t.id ? '#38bdf8' : '#64748b', marginTop:2 }}>{t.label}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Raio */}
          <div className="form-group" style={{ marginBottom:12 }}>
            <label>Raio de detecção (metros)</label>
            <div style={{ display:'flex', gap:6, marginBottom:6 }}>
              {['50','100','200','500','1000'].map(r => (
                <button key={r} onClick={() => setForm({...form, raio_metros:r})}
                  style={{ flex:1, padding:'5px 2px', borderRadius:6, fontSize:10,
                    border: form.raio_metros===r ? '1px solid #0ea5e9' : '1px solid #2d4166',
                    background: form.raio_metros===r ? '#0c2a4a' : 'transparent',
                    color: form.raio_metros===r ? '#38bdf8' : '#64748b',
                    cursor:'pointer', fontFamily:'Inter' }}>
                  {parseInt(r)>=1000 ? `${parseInt(r)/1000}km` : `${r}m`}
                </button>
              ))}
            </div>
            <input type="number" value={form.raio_metros}
              onChange={e => setForm({...form, raio_metros:e.target.value})}
              placeholder="Ou digite o raio em metros" min={10} max={10000} />
          </div>

          {/* Localização */}
          <div className="form-group" style={{ marginBottom:12 }}>
            <label>Localização *</label>
            <div style={{
              background: selecionandoMapa ? '#0c2a4a' : '#1e2f4a',
              border:`1px solid ${selecionandoMapa ? '#0ea5e9' : '#2d4166'}`,
              borderRadius:8, padding:12, marginBottom:8
            }}>
              {form.latitude && form.longitude ? (
                <div>
                  <div style={{ fontSize:12, color:'#22c55e', marginBottom:4 }}>✅ Localização definida</div>
                  <div style={{ fontSize:11, color:'#94a3b8' }}>
                    {parseFloat(form.latitude).toFixed(6)}, {parseFloat(form.longitude).toFixed(6)}
                  </div>
                </div>
              ) : (
                <div style={{ fontSize:12, color: selecionandoMapa ? '#38bdf8' : '#64748b' }}>
                  {selecionandoMapa ? '👆 Clique no mapa para marcar o ponto' : '📍 Nenhuma localização selecionada'}
                </div>
              )}
            </div>
            <button className={`btn ${selecionandoMapa ? 'btn-danger' : 'btn-primary'}`}
              style={{ width:'100%', justifyContent:'center' }}
              onClick={() => setSelecionandoMapa(s => !s)}>
              {selecionandoMapa ? '⏹ Cancelar seleção' : '📍 Selecionar no mapa'}
            </button>
          </div>

          <div className="form-group" style={{ marginBottom:12 }}>
            <label>Endereço (opcional)</label>
            <input value={form.endereco} onChange={e => setForm({...form, endereco:e.target.value})}
              placeholder="Rua, número, bairro..." />
          </div>

          <div className="form-group">
            <label>Observações</label>
            <input value={form.observacoes} onChange={e => setForm({...form, observacoes:e.target.value})}
              placeholder="Opcional" />
          </div>
        </div>

        <div style={{ padding:16, borderTop:'1px solid #2d4166' }}>
          <button className="btn btn-primary" style={{ width:'100%', justifyContent:'center', padding:'12px' }}
            onClick={salvar} disabled={!form.nome || !form.latitude}>
            💾 Salvar ponto
          </button>
        </div>
      </div>

      {/* Mapa */}
      <div style={{ flex:1 }}>
        <MapContainer center={centro} zoom={5} style={{ width:'100%', height:'100%' }}>
          <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
          <ClicarMapa ativo={selecionandoMapa} onCoordenada={onCoordenada} />

          {/* Ponto sendo criado */}
          {form.latitude && form.longitude && (
            <>
              <Marker
                position={[parseFloat(form.latitude), parseFloat(form.longitude)]}
                icon={L.divIcon({
                  html:`<div style="background:#0ea5e9;width:16px;height:16px;border-radius:50%;border:3px solid white;box-shadow:0 2px 8px rgba(0,0,0,0.4)"></div>`,
                  className:'', iconSize:[16,16], iconAnchor:[8,8]
                })}>
                <Popup><strong>{form.nome || 'Novo ponto'}</strong></Popup>
              </Marker>
              <Circle
                center={[parseFloat(form.latitude), parseFloat(form.longitude)]}
                radius={parseInt(form.raio_metros)||100}
                pathOptions={{ color:'#0ea5e9', fillOpacity:0.15, weight:2 }} />
            </>
          )}

          {/* Pontos existentes */}
          {pontos.map((p:any) => (
            <React.Fragment key={p.id}>
              <Marker position={[parseFloat(p.latitude), parseFloat(p.longitude)]}
                icon={L.divIcon({
                  html:`<div style="background:#22c55e;width:14px;height:14px;border-radius:50%;border:2px solid white;box-shadow:0 1px 4px rgba(0,0,0,0.3)"></div>`,
                  className:'', iconSize:[14,14], iconAnchor:[7,7]
                })}>
                <Popup><strong>{p.nome}</strong><br/>{p.tipo}<br/>Raio: {p.raio_metros}m</Popup>
              </Marker>
              <Circle center={[parseFloat(p.latitude), parseFloat(p.longitude)]}
                radius={p.raio_metros}
                pathOptions={{ color:'#22c55e', fillOpacity:0.08, weight:1, dashArray:'4,4' }} />
            </React.Fragment>
          ))}
        </MapContainer>
      </div>
    </div>
  )

  return (
    <div style={{ padding:24, overflowY:'auto', height:'100%' }}>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:20 }}>
        <div>
          <h2 style={{ fontSize:20, fontWeight:700 }}>Pontos de interesse</h2>
          <p style={{ fontSize:13, color:'#64748b' }}>{pontos.length} ponto(s) cadastrado(s)</p>
        </div>
        <button className="btn btn-primary" onClick={() => setModo('novo')}>+ Novo ponto</button>
      </div>

      {/* Abas */}
      <div style={{ display:'flex', gap:0, marginBottom:20, borderBottom:'1px solid #2d4166' }}>
        {[
          { id:'pontos',  label:`📍 Pontos (${pontos.length})` },
          { id:'visitas', label:`🚗 Visitas (${visitas.length})` },
        ].map(aba => (
          <button key={aba.id} onClick={() => setAbaAtiva(aba.id as any)}
            style={{ padding:'10px 20px', border:'none', background:'transparent', cursor:'pointer',
              color: abaAtiva===aba.id ? '#38bdf8' : '#64748b', fontSize:13, fontFamily:'Inter',
              borderBottom: abaAtiva===aba.id ? '2px solid #0ea5e9' : '2px solid transparent',
              fontWeight: abaAtiva===aba.id ? 600 : 400 }}>
            {aba.label}
          </button>
        ))}
      </div>

      {abaAtiva === 'pontos' && (
        <>
          {pontos.length === 0 ? (
            <div className="card" style={{ textAlign:'center', padding:48 }}>
              <div style={{ fontSize:48, marginBottom:12 }}>📍</div>
              <div style={{ fontSize:16, fontWeight:600, marginBottom:8 }}>Nenhum ponto cadastrado</div>
              <div style={{ fontSize:13, color:'#64748b', marginBottom:20 }}>
                Cadastre clientes, obras, postos e outros locais para monitorar visitas dos veículos
              </div>
              <button className="btn btn-primary" onClick={() => setModo('novo')}>Cadastrar primeiro ponto</button>
            </div>
          ) : (
            <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(280px,1fr))', gap:16 }}>
              {pontos.map((p:any) => {
                const tipo = TIPOS.find(t => t.id === p.tipo) || TIPOS[0]
                const qtdVisitas = visitas.filter(v => v.ponto_id === p.id).length
                return (
                  <div key={p.id} className="card">
                    <div style={{ display:'flex', alignItems:'flex-start', gap:12, marginBottom:10 }}>
                      <span style={{ fontSize:28 }}>{tipo.icone}</span>
                      <div style={{ flex:1 }}>
                        <div style={{ fontWeight:600, fontSize:14 }}>{p.nome}</div>
                        <span className="badge badge-azul" style={{ fontSize:10 }}>{tipo.label}</span>
                      </div>
                      <span className={`badge badge-${p.ativo?'verde':'cinza'}`}>{p.ativo?'Ativo':'Inativo'}</span>
                    </div>
                    <div style={{ fontSize:12, color:'#94a3b8', marginBottom:4 }}>
                      📏 Raio: {p.raio_metros >= 1000 ? `${p.raio_metros/1000}km` : `${p.raio_metros}m`}
                    </div>
                    {p.endereco && <div style={{ fontSize:11, color:'#64748b', marginBottom:4 }}>📍 {p.endereco}</div>}
                    <div style={{ fontSize:11, color:'#475569', marginBottom:12 }}>
                      🚗 {qtdVisitas} visita(s) registrada(s)
                    </div>
                    <div style={{ display:'flex', gap:8 }}>
                      <button className="btn btn-ghost" style={{ fontSize:11, flex:1, justifyContent:'center' }}
                        onClick={() => setAbaAtiva('visitas')}>
                        Ver visitas
                      </button>
                      <button className="btn btn-danger" style={{ fontSize:11, padding:'6px 10px' }}
                        onClick={() => excluir(p.id)}>🗑</button>
                    </div>
                  </div>
                )
              })}
            </div>
          )}
        </>
      )}

      {abaAtiva === 'visitas' && (
        <div className="card" style={{ padding:0, overflow:'hidden' }}>
          <table>
            <thead><tr>
              <th>Veículo</th><th>Ponto visitado</th><th>Chegada</th><th>Saída</th><th>Duração</th><th>Status</th>
            </tr></thead>
            <tbody>
              {visitas.length === 0 ? (
                <tr><td colSpan={6} style={{ textAlign:'center', padding:32, color:'#64748b' }}>
                  Nenhuma visita registrada ainda
                </td></tr>
              ) : visitas.map((v:any) => (
                <tr key={v.id}>
                  <td>
                    <div style={{ fontWeight:500 }}>{v.ativo_nome}</div>
                    {v.placa && <div style={{ fontSize:11, color:'#64748b' }}>{v.placa}</div>}
                  </td>
                  <td>
                    <div style={{ fontWeight:500 }}>{v.ponto_nome}</div>
                    <div style={{ fontSize:11, color:'#64748b' }}>{v.ponto_tipo}</div>
                  </td>
                  <td style={{ fontSize:12 }}>{new Date(v.chegada).toLocaleString('pt-BR')}</td>
                  <td style={{ fontSize:12, color:'#94a3b8' }}>
                    {v.saida ? new Date(v.saida).toLocaleString('pt-BR') : '—'}
                  </td>
                  <td style={{ fontSize:12, color:'#0ea5e9', fontWeight:500 }}>
                    {formatarDuracao(v.duracao_min)}
                  </td>
                  <td>
                    <span className={`badge badge-${v.em_andamento ? 'verde' : 'cinza'}`}>
                      {v.em_andamento ? '● No local' : 'Concluída'}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
}
